export const onPreviewSectionClick = (
  id: string,
  options: { accordion?: boolean; highlight?: boolean } = {
    accordion: true,
    highlight: true,
  },
) => {
  if (!id) return;
  const targetElement = document.getElementById(`${id}`);
  // const input = document.getElementById(`${id}-input`);
  // if (input) {
  //   input.focus();
  // }

  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: "smooth",
    });

    const accordionTrigger = targetElement.querySelector(
      'button[type="button"][data-state]',
    ) as HTMLElement;

    if (
      accordionTrigger &&
      accordionTrigger.getAttribute("data-state") === "closed" &&
      options?.accordion
    ) {
      accordionTrigger.click();
    }

    if (targetElement && options?.highlight) {
      targetElement.classList.add("highlight-clicked");
      setTimeout(() => {
        targetElement.classList.remove("highlight-clicked");
      }, 2000);
    }
  }
};
